// extracted by mini-css-extract-plugin
export default {"loginlogo":"styles_loginlogo__EF5yK","signwith":"styles_signwith__8g8K8"};